import { createRouter, createWebHistory } from 'vue-router';
import Layout from './components/Layout';

import DocumentationLayout from './components/DocumentationLayout.vue';
import DocumentationGettingStarted from './views/documentation/GettingStarted.vue';

import Login from './views/Login';
import AppPreview from './views/AppPreview';
import ForgotPassword from './views/ForgotPassword';
import ResetPassword from './views/ResetPassword';
// import AdminList from './views/admins/List';
// import AdminForm from './views/admins/Form';

const withPrefix = (prefix, routes) =>
	routes.map((route) => ({
		...route,
		path: prefix + route.path,
	}));

const router = createRouter({
	history: createWebHistory(import.meta.env.BASE_URL),
	routes: [
		{
			path: '/',
			name: 'login',
			component: Login,
		},
		{
			path: '/forgot-pass',
			name: 'forgot-password',
			component: ForgotPassword,
		},
		{
			path: '/reset-pass/:token',
			name: 'reset-password',
			component: ResetPassword,
		},
		{
			path: '/app',
			name: 'app',
			component: Layout,
			children: [
				{
					path: '',
					name: 'app-index',
					redirect: { name: 'dashboard' },
				},
				{
					path: 'dashboard',
					name: 'dashboard',
					component: () => import('./views/reports/DashboardPage.vue'),
				},
				{
					path: 'dashboard/edit',
					name: 'dashboard-edit',
					component: () => import('./views/reports/DashboardBuilderPage.vue'),
				},
				{
					path: 'app-preview',
					name: 'app-preview',
					component: AppPreview,
				},
				{
					path: 'about',
					name: 'about',
					component: () => import('./views/About.vue'),
				},
				{
					path: 'external-offers',
					name: 'external-offers',
					component: () => import('./views/external-offers/List.vue'),
				},
        // {
        // 	path: 'statistics',
        // 	name: 'statistics',
        // 	component: () => import(/* webpackChunkName: 'statistics' */ './views/reports/Statistics.vue')
        // },
				{
					path: 'statistics',
					name: 'statistics',
					component: () => import('./views/reports/PublisherStatistics.vue'),
				},
				{
					path: 'reports',
					name: 'reports',
					component: () => import('./views/reports/Reports.vue'),
				},
				{
					path: 'clicks',
					name: 'clicks',
					component: () => import('./views/reports/ClickList.vue'),
				},
				{
					path: 'click/:id',
					name: 'click-view',
					component: () => import('./views/reports/ClickView.vue'),
				},
				{
					path: 'conversions',
					name: 'conversions',
					component: () => import('./views/reports/Conversions.vue'),
				},
				{
					path: 'pub_conversions',
					name: 'pub_conversions',
					component: () => import('./views/reports/PublisherConversions.vue'),
				},
				{
					path: 'subsources',
					name: 'subsources',
					component: () => import('./views/Subsources.vue'),
				},
				{
					path: 'click-search',
					name: 'click-search',
					component: () => import('./views/reports/ClickSearch.vue'),
				},
				{
					path: 'pa-reports',
					name: 'pa-reports',
					component: () => import('./views/reports/PostAttribution.vue'),
				},
				{
					path: 'url-scanner',
					name: 'url-scanner',
					component: () => import('./views/UrlScanner.vue'),
				},
				{
					path: 'events',
					name: 'events',
					component: () => import('./views/reports/Events.vue'),
				},
				{
					path: 'rejected',
					name: 'rejected',
					component: () => import('./views/reports/Rejected.vue'),
				},
				{
					path: 'postback-log',
					name: 'postback-log',
					component: () => import('./views/monitor/PostbackLog.vue'),
				},
				{
					path: 'publisher-postbacks',
					name: 'publisher-postbacks',
					component: () => import('./views/monitor/PublisherPostback.vue'),
				},
				{
					path: 'activity-log',
					name: 'activity-log',
					component: () => import('./views/monitor/ActivityLog.vue'),
				},
				{
					path: 'kpi-rule-log',
					name: 'kpi-rule-log',
					component: () => import('./views/monitor/KpiRuleLog.vue'),
				},
				{
					path: 'settings',
					name: 'settings',
					component: () => import('./views/Settings.vue'),
				},
				{
					path: 'reports-settings',
					name: 'reports-settings',
					component: () => import('./views/reports/ReportsSettings/ReportsSettings.vue'),
				},
				{
					path: 'devices-blacklist',
					name: 'devices-blacklist',
					component: () => import('./views/DevicesBlacklist.vue'),
				},
				{
					path: 'kpi-rules',
					name: 'kpi-rules',
					component: () => import('./views/KpiRules'),
				},
				{
					path: 'countries',
					name: 'countries',
					component: () => import('./views/data/Countries.vue'),
				},
				{
					path: 'regions',
					name: 'regions',
					component: () => import('./views/data/Regions.vue'),
				},
				{
					path: 'cities',
					name: 'cities',
					component: () => import('./views/data/Cities.vue'),
				},
				{
					path: 'ipinfo',
					name: 'ipinfo',
					component: () => import('./views/data/IPInfo.vue'),
				},

				{
					path: 'tags',
					redirect: { name: 'external-placements' },
				},
				{
					path: 'external-placements',
					name: 'external-placements',
					component: () => import('./views/data/Tags.vue'),
				},

				{
					path: 'notifications',
					redirect: { name: 'offer-list', query: { attention: 'needs-attention' } },
				},
				{
					path: 'rule-notifications',
					redirect: { name: 'kpi-rule-log' },
				},
				{
					path: 'updates',
					name: 'updates',
					component: () => import('./views/notifications/Updates.vue'),
				},
				{
					name: 'profile',
					path: 'profile',
					component: () => import('./views/users/Profile.vue'),
				},

				...withPrefix('admins', [
					{
						name: 'admin-list',
						path: '',
						component: () => import('./views/admins/List.vue'),
					},
					{
						name: 'admin-add',
						path: '/add',
						component: () => import('./views/admins/Form.vue'),
					},
					{
						name: 'admin-edit',
						path: '/edit/:id',
						component: () => import('./views/admins/Form.vue'),
					},
				]),
				...withPrefix('users', [
					{
						name: 'user-list',
						path: '',
						component: () => import('./views/users/List.vue'),
					},
					{
						name: 'user-add',
						path: '/add',
						component: () => import('./views/users/Form.vue'),
					},
					{
						name: 'user-edit',
						path: '/edit/:id',
						component: () => import('./views/users/Form.vue'),
					},
				]),

				...withPrefix('offer-templates', [
					{
						name: 'offer-template-list',
						path: '',
						component: () => import('./views/offer-templates/List.vue'),
					},
					{
						name: 'offer-template-add',
						path: '/add',
						component: () => import('./views/offer-templates/Form.vue'),
					},
					{
						name: 'offer-template-edit',
						path: '/edit/:id',
						component: () => import('./views/offer-templates/Form.vue'),
					},
				]),

				...withPrefix('advertisers', [
          {
            name: 'advertiser-list',
            path: '',
            component: () => import('./views/advertisers/List.vue'),
          },
          {
            name: 'advertiser-add',
            path: '/add',
            component: () => import('./views/advertisers/Form.vue'),
          },
          {
            name: 'advertiser-edit',
            path: '/edit/:id',
            component: () => import('./views/advertisers/Form.vue'),
          },
        ]),

				...withPrefix('publishers', [
          {
            name: 'publisher-list',
            path: '',
            component: () => import('./views/publishers/List.vue'),
          },
          {
            name: 'publisher-add',
            path: '/add',
            component: () => import('./views/publishers/Form.vue'),
          },
          {
            name: 'publisher-edit',
            path: '/edit/:id',
            component: () => import('./views/publishers/Form.vue'),
          },
          {
            name: 'publisher-api',
            path: '/api/:id',
            component: () => import('./views/publishers/API.vue'),
          },
        ]),

				...withPrefix('offers', [
          {
            name: 'offer-list',
            path: '',
            component: () => import('./views/offers/List.vue'),
          },

          /**
           * @link https://app.clickup.com/t/86er6tj18 Fallback disabled for now
           */
          // {
          //   name: 'offer-fallback',
          //   path: '/fallback',
          //   component: () => import('./views/offers/FallbackForm.vue'),
          // },

          {
            name: 'offer-create',
            path: '/create',
            component: () => import('./views/offers/CreateWizard.vue'),
          },
          {
            name: 'offer-add',
            path: '/add',
            component: () => import('./views/offers/Form.vue'),
          },
          {
            name: 'offer-view',
            path: '/view/:id',
            component: () => import('./views/offers/OfferView.vue'),
          },
          {
            name: 'offer-overview-edit',
            path: '/overview/edit',
            component: () => import('./views/reports/DashboardBuilderPage.vue'),
            meta: {
              dashboardApiBase: 'dashboard/offer-overview',
              dashboardBuilderTitle: 'Offer Overview Settings',
              dashboardBuilderBreadcrumb: 'Offers › Overview Settings',
              dashboardCancelRouteName: 'offer-view',
            },
          },
          {
            name: 'complex-offer-overview-edit',
            path: '/complex-overview/edit',
            component: () => import('./views/reports/DashboardBuilderPage.vue'),
            meta: {
              dashboardApiBase: 'dashboard/complex-offer-overview',
              dashboardBuilderTitle: 'Complex Offer Overview Settings',
              dashboardBuilderBreadcrumb: 'Offers › Complex Overview Settings',
              dashboardCancelRouteName: 'offer-view',
            },
          },
          {
            name: 'offer-edit',
            path: '/edit/:id',
            component: () => import('./views/offers/Form.vue'),
          },
          {
            name: 'complex-add',
            path: '/add-complex',
            component: () => import('./views/offers/ComplexForm.vue'),
          },
          {
            name: 'complex-edit',
            path: '/edit-complex/:id',
            component: () => import('./views/offers/ComplexForm.vue'),
          },
          {
            name: 'offer-targeting',
            path: '/targeting/:id',
            component: () => import('./views/offers/Targeting.vue'),
          },
          {
            name: 'offer-default-settings',
            path: '/default-settings',
            redirect: { name: 'offer-template-list' },
          },
          {
            name: 'complex-offer-default-settings',
            path: '/complex-default-settings',
            component: () => import('./views/offers/ComplexDefaultSettings.vue'),
          },
          {
            name: 'offer-notifications',
            path: '/notifications',
            component: () => import('./views/offers/Notifications.vue'),
          },
          {
            name: 'offer-supply-management',
            path: '/supply-management/:id',
            component: () => import('./views/offers/SupplyManagementForm/SupplyManagementForm.vue'),
          },
        ]),

				...withPrefix('placements', [
          {
            name: 'placement-list',
            path: '',
            component: () => import('./views/placements/List.vue'),
          },
          {
            name: 'placement-edit',
            path: '/edit/:id',
            component: () => import('./views/placements/Form.vue'),
          },
          {
            name: 'placement-targeting',
            path: '/targeting/:id',
            component: () => import('./views/placements/Targeting.vue'),
          },
          {
            name: 'placement-default-settings',
            path: '/default-settings',
            component: () => import('./views/placements/DefaultSettings.vue'),
          },
          {
            name: 'placement-test',
            path: '/test/:id',
            component: () => import('./views/placements/Test.vue'),
          },
        ]),

				...withPrefix('mmp-accounts', [
          {
            name: 'mmp-account-list',
            path: '',
            component: () => import('./views/mmp-accounts/List.vue'),
          },
          {
            name: 'mmp-account-add',
            path: '/add',
            component: () => import('./views/mmp-accounts/Form.vue'),
          },
          {
            name: 'mmp-account-edit',
            path: '/edit/:id',
            component: () => import('./views/mmp-accounts/Form.vue'),
          },
          {
            path: '/reports',
            name: 'mmp-account-reports',
            component: () => import('./views/reports/MmpAccountReports.vue'),
          },
        ]),
				...withPrefix('devices', [
          {
            name: 'device-list',
            path: '',
            component: () => import('./views/devices/List.vue'),
          },
          {
            name: 'device-add',
            path: '/add',
            component: () => import('./views/devices/Form.vue'),
          },
          {
            name: 'device-edit',
            path: '/edit/:id',
            component: () => import('./views/devices/Form.vue'),
          },
        ]),
				...withPrefix('countries', [
          {
            path: '',
            name: 'countries',
            component: () => import('./views/data/Countries.vue'),
          },
        ]),
				...withPrefix('regions', [
          {
            path: '',
            name: 'regions',
            component: () => import('./views/data/Regions.vue'),
          },
        ]),
				...withPrefix('cities', [
          {
            path: '',
            name: 'cities',
            component: () => import('./views/data/Cities.vue'),
          },
        ]),
				...withPrefix('finance', [
          {
            name: 'finance-summary',
            path: '/summary',
            component: () => import('./views/finance/MonthSummary'),
          },
          {
            name: 'finance-list',
            path: '/summary-list',
            component: () => import('./views/finance/Summary.vue'),
          },
          // {
          // 	name: 'finance-month-summary',
          // 	path: '/summary/month/:month',
          // },
          {
            name: 'legal-entity-list',
            path: '/legal-entities',
            component: () => import('./views/legal-entities/List.vue'),
          },
          {
            name: 'legal-entity-add',
            path: '/legal-entities/add',
            component: () => import('./views/legal-entities/Form.vue'),
          },
          {
            name: 'legal-entity-edit',
            path: '/legal-entities/edit/:id',
            component: () => import('./views/legal-entities/Form.vue'),
          },
          {
            name: 'finance-advertisers',
            path: '/advertisers',
            component: () => import('./views/finance/Advertisers.vue'),
          },
          {
            name: 'finance-publishers',
            path: '/publishers',
            component: () => import('./views/finance/Publishers'),
          },
          {
            name: 'documents',
            path: '/documents',
            component: () => import('./views/finance/Documents'),
          },
        ]),
				...withPrefix('support', [
          {
            name: 'support-tickets-list',
            path: '',
            component: () => import('./views/support/List.vue'),
          },
          {
            name: 'support-ticket-edit',
            path: '/edit/:id',
            component: () => import('./views/support/Form.vue'),
          },
          {
            name: 'support-ticket-add',
            path: '/add',
            component: () => import('./views/support/Form.vue'),
          },
        ]),
				{
					path: 'conversion-reports',
					name: 'conversion-reports',
					component: () => import('./views/reports/ConversionReports.vue'),
				},
				{
					path: 'external-cost-data',
					name: 'external-cost-data',
					component: () => import('./views/reports/ExternalCostDataReports.vue'),
				},
        // {
        // 	path: 'advertisers',
        // 	name: 'advertisers',
        // 	component: {
        // 		render (c) { return c('router-view') }
        // 	},
        // 	children: [
        //
        // 	]
        // },
			],
		},
    // {
    // 	path: '/about',
    // 	name: 'about',
    // 	meta: {layout: 'default'},
    // 	// route level code-splitting
    // 	// this generates a separate chunk (about.[hash].js) for this route
    // 	// which is lazy-loaded when the route is visited.
    // 	component: () => import(/* webpackChunkName: 'about' */ './views/About.vue')
    // }
		{
			name: 'docs',
			path: '/docs',
			component: DocumentationLayout,
			children: [
				{
					path: '',
					name: 'docs-index',
					redirect: { name: 'getting-started' },
				},
				{
					name: 'getting-started',
					path: 'getting-started',
					component: DocumentationGettingStarted,
				},
				{
					name: 'article',
					path: ':slug',
					component: () => import('./views/documentation/Article.vue'),
				},
			],
		},
	],
});

export default router;
